import { isAddress } from '@components/Web3/Wallet/useGetWalletParam'
import { PublicKey } from '@solana/web3.js'
import {
    getBlockAbove,
    insertNodes,
    insertText,
    isEndPoint,
    moveSelection,
} from '@udecode/plate-common'
import { createPlatePlugin, TPlateEditor } from '@udecode/plate-common/react'

import { TContractAddressElement } from '../components/plate-ui/autocomplete/types'

import { ELEMENT_CONTRACT_ADDRESS } from './createContractAddressPlugin'

export const PasteContractAddressPlugin = createPlatePlugin({
    key: 'ethAddressPlugin',
    extendEditor: ({ editor }: { editor: TPlateEditor }) => {
        const { insertData } = editor

        editor.insertData = (data) => {
            const text = data.getData('text/plain')?.trim()

            const chain = getChainFromAddress(text)

            if (!chain) {
                insertData(data)
                return editor
            }

            insertNodes<TContractAddressElement>(editor, [
                {
                    type: ELEMENT_CONTRACT_ADDRESS,
                    value: text,
                    address: text,
                    chain: chain,
                    children: [{ text: '' }],
                },
            ])

            // move the selection after the element
            moveSelection(editor, { unit: 'offset' })

            const pathAbove = getBlockAbove(editor)?.[1]

            const isBlockEnd =
                editor.selection &&
                pathAbove &&
                isEndPoint(editor, editor.selection.anchor, pathAbove)

            if (isBlockEnd) {
                insertText(editor, ' ')
            }

            return
        }

        return editor
    },
})

// loose peemptive validation for contract address
const base58regex = /^[1-9A-HJ-NP-Za-km-z]{32}/

// validates base / solana address and returns the chain id
export const getChainFromAddress = (text: string) => {
    if (!text || typeof text !== 'string' || text.length < 32 || text.length > 44) {
        return null
    }
    if (isAddress(text)) {
        return '8453'
    }
    if (isSolanaAddress(text)) {
        return 'solana-mainnet'
    }

    return null
}

export const isSolanaAddress = (text: string, curveCheck = false) => {
    if (!base58regex.test(text)) {
        return false
    }

    try {
        const publicKey = new PublicKey(text)
        return !curveCheck ? !!publicKey : PublicKey.isOnCurve(publicKey.toBytes())
    } catch {
        return false
    }
}
